import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useRef, useEffect } from "react";
import { faBell, faEnvelope } from "@fortawesome/free-solid-svg-icons";

const NotificationComponent = () => {
  const [show, setShow] = useState(false);
  const menuRef = useRef(null);

  // Click outside to close modal
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="position-relative" ref={menuRef}>
      {/* Bell Icon */}
      <div
        id="notification_header_icon"
        className="notification pt-1 position-relative"
        onClick={() => setShow(!show)}
        style={{ cursor: "pointer" }}
      >
        <FontAwesomeIcon icon={faBell} color="#ffffff" size="xl" />
      </div>

      {/* Notification Box */}
      {show && (
        <div
          className={`notification-menu ${show ? "active" : ""}`}
          id="menunotification_menu"
        >
          <h6 className="fs-5 fw-semibold px-3 pt-3 pb-3 border-bottom mb-3">
            Notifications
          </h6>
          <ul>
            <li className="px-3">No New Notification!</li>
          </ul>
          <div className="viewallNotification text-end pe-3 pt-2">
            <a href="/account/notification" className="follow_message ms-3">
              View all notifications
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationComponent;